import { useState } from 'react';
export function useModalState() {
    const [modalState, setModalState] = useState({
        isOpen: false,
        modelId: -1,
    });
    return {
        open: (modelId) => setModalState({ isOpen: true, modelId }),
        close: () => setModalState({ isOpen: false, modelId: -1 }),
        modalState,
    };
}
